function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#ff4f8b;}.cls-2{fill:#232f3e;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "AWS-CloudTrail_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Pink_Dark_BG",
  "data-name": "Pink Dark BG",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Product_Icon",
  "data-name": "Product Icon"
}, React.createElement("path", {
  className: "cls-2",
  d: "M55.48,35a6,6,0,0,0-3.91-5.58,5.63,5.63,0,0,0-5.15.84,13.13,13.13,0,0,0-2.66-3.82,11.94,11.94,0,0,0-13.35-2.61,12.23,12.23,0,0,0-7.06,10.85l0,.54a8.27,8.27,0,0,0-5.35,5h2.18a6.65,6.65,0,0,1,4.46-3.33,1,1,0,0,0,.75-1l-.08-1.27a10.31,10.31,0,0,1,5.83-8.95,10,10,0,0,1,11.19,2.2,11.69,11.69,0,0,1,2.76,4.48,1,1,0,0,0,.8.65,1,1,0,0,0,.94-.39,3.64,3.64,0,0,1,4.07-1.29c1.65.55,2.59,2.16,2.59,4.34a1,1,0,0,0,.82,1.14c1.84.32,6.14,1.6,6.14,6.7,0,6.09-6,6.73-6.18,6.75H33.52v2H54.4c2.8-.25,8.08-2.4,8.08-8.75C62.48,38.43,59,35.82,55.48,35Zm-41,17.25h-2v-2h2Zm9,0h-7v-2h7Zm8,0h-6v-2h6Zm-9-4h-9v-2h9Zm19,0h-12v-2h12Zm-10-4h-6v-2h6Zm-8,0h-8v-2h8Zm4,4h-3v-2h3Z"
})));

var SvgAwsCloudTrail = function SvgAwsCloudTrail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsCloudTrail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-CloudTrail.3d1f7fdb.svg";
export { ForwardRef as ReactComponent };